import { GET_POOL_HASHRATE_STATS } from '../actions/types';

export default (state = null, action) => {
  switch (action.type) {
    case GET_POOL_HASHRATE_STATS:
      return action.payload;
    default:
      return state;
  }
};
